<div class="customer-info-form-container">
  <div class="customer-info-form">
    <div class="body">

      <div class="customer-info-form-column">
        <div class="common-form-container">

           <!-- Titre -->
          <div class="header">
            {{ 'popins.forgotten_password.title' | translate }}
          </div>

          <!-- Info -->
          <div class="input-row">
            <div class="form-input">
              <span class="label">
                {{ 'popins.forgotten_password.info' | translate }}
              </span>
            </div>
          </div>

        </div>
      </div>

    </div>

    <!-- FOOTER -->
    <div class="footer">
      <div class="actions text-center">
        <ng-casto-button
          class="blue"
          [label]="'popins.forgotten_password.confirm' | translate"
          (click)="modalService.close()">
        </ng-casto-button>
      </div>
    </div>

  </div>
</div>
